module.exports = __webpack_public_path__ + "static/media/carrara-reg-webfont.07827245.woff2";